import { render, staticRenderFns } from "./BaseInputFloatingLabel.vue?vue&type=template&id=15b8c56c&"
import script from "./BaseInputFloatingLabel.vue?vue&type=script&lang=js&"
export * from "./BaseInputFloatingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports